export const getAuthUrl = (redirect_to?: string) => {
  const url = new URL('/oauth2/login', window.location.href);

  if (redirect_to) {
    url.searchParams.set('redirect_to', redirect_to);
  }

  return url.toString();
};

export const setAccessToken = (access_token: string) => {
  localStorage.setItem('access_token', access_token);
};

export const getAccessToken = () => {
  return localStorage.getItem('access_token');
};

export const clearAccessToken = () => {
  return localStorage.removeItem('access_token');
};

export const isAccessTokenExpiringSoon = (timestamp: number | undefined) => {
  return (timestamp ?? 0) * 1000 - Date.now() <= 60_000;
};
